<template>
  <modal id="deleteAbsence" v-cloak>
    <div slot="title">
      <h3>Wilt u volgende afwezigheid verwijderen?</h3>
      <h3>{{ this.getAbsenceTitle }}</h3>
    </div>
    <div slot="body" class="card">
      <div slot="footer">
        <button
            class="btn btn-danger"
            @click="handleDeleteAbsence">
          Verwijder afwezigheid
        </button>
      </div>
    </div>
  </modal>
</template>
<script>

import {VoerroModal} from "@voerro/vue-modal";
import moment from "moment";
import {mapActions} from "vuex";
import {toDateMonthYear, toYearAndMonth} from "@/util/DateUtil";

export default {
  name: "deleteAbsenceModal",
  props: ['currentCalendarEntry'],
  data: () => ({
    absenceType: {},
  }),
  computed: {
    getAbsenceTitle() {
      return this.currentCalendarEntry.title + " - " + toDateMonthYear(this.currentCalendarEntry.start);
    }
  },
  methods: {
    ...mapActions("timesheet", ['removeAbsence']),
    handleDeleteAbsence() {
      const dayOfMonth = moment(this.currentCalendarEntry.start).date();
      const absenceCategory = this.currentCalendarEntry.extendedProps.absenceCategory;
      const fullDay = this.currentCalendarEntry.extendedProps.fullDay;
      const yearMonth = toYearAndMonth(this.currentCalendarEntry.start);

      const removeAbsenceDto = {
        dayOfMonth,
        absenceCategory,
        fullDay
      };

      this.removeAbsence({yearMonth, removeAbsenceDto});
      VoerroModal.hide("deleteAbsence");
    },
  }
};
</script>

<style scoped>

</style>